import React from 'react'
import { useTranslation } from 'react-i18next'

import { ContentStateProperty, ScreenProperty } from '../../../../../../../@types/types'
import { SCREEN_OTHER_FACILITIES, SCREENS } from '../../../../../../../services/domain/wizardScreens'
import ToggleSwitch from '../../../../../../common/inputs/toggleSwitch/ToggleSwitch'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'
import CombinedFieldItem from '../../../../../../common/inputs/combinedFieldItem/CombinedFieldItem'
import { camelCaseToDash } from '../../../../../../../utils/text/text-utils'

const screen = SCREENS[SCREEN_OTHER_FACILITIES]

export interface LoadLiftingProps {
  toggleEnabled?: boolean
  amountValue?: string
  validation?: string[]
  onChange: (property: ContentStateProperty, value: string | boolean | undefined) => void
  doReset?: (clearingUpOf: ScreenProperty[]) => void
}

type Properties = {
  booleanPropertyName: ContentStateProperty
  amountPropertyName: ContentStateProperty
}
export const LoadLiftingComponent: React.FC<LoadLiftingProps & Properties> = ({
  toggleEnabled,
  amountValue,
  validation,
  onChange,
  doReset,
  booleanPropertyName,
  amountPropertyName,
}) => {
  const { t } = useTranslation()
  const doToggle = () => {
    if (toggleEnabled) {
      callReset()
    } else {
      onChange(booleanPropertyName, true)
    }
  }

  const callReset = () =>
    doReset?.([
      {
        screen: screen.name,
        property: booleanPropertyName,
      },
      {
        screen: screen.name,
        property: amountPropertyName,
      },
    ])

  return (
    <div className='grid-item one-whole'>
      <ToggleSwitch
        id={camelCaseToDash(booleanPropertyName)}
        alignment='custom'
        propertyName={booleanPropertyName}
        label={<span>{t(`wizard.screen.otherFacilities.${booleanPropertyName}`, 'Load Lifting')}</span>}
        value={toggleEnabled ?? false}
        onChange={doToggle}
      />

      {toggleEnabled && (
        <CombinedFieldItem
          id={camelCaseToDash(amountPropertyName)}
          label={t(`wizard.screen.otherFacilities.${amountPropertyName}`, 'Load Capacity')}
          wrapperClassName='margin-top-l'
          children={
            <TextInput
              id={camelCaseToDash(amountPropertyName)}
              propertyName={amountPropertyName}
              placeholder=''
              label=''
              value={amountValue}
              type='text'
              affixRight='unit'
              unitRight='kg'
              maxLength={9}
              errors={validation ?? []}
              doOnFieldChange={(property, value) => onChange(property, value !== '' ? value : undefined)}
            />
          }
        />
      )}
    </div>
  )
}
